require('./bootstrap')

require('admin-lte/plugins/bootstrap/js/bootstrap.min')
require('admin-lte/plugins/daterangepicker')
require('admin-lte/plugins/select2/js/select2.min')
require('admin-lte/plugins/select2/js/i18n/pt-BR')
require('admin-lte/plugins/chart.js/Chart.min')
require('admin-lte')

require('jquery-maskmoney/dist/jquery.maskMoney.min.js')
require('jquery.maskedinput/src/jquery.maskedinput.js')

require('./modules/input-file.js')
require('./modules/confirm.js')
require('./modules/globals.js')

require('./menu')
